import "core-js/modules/es.array.find-index";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import GetAllDistricts from '@/mixins/get-districts';
import AppSimpleSelector from './AppSimpleSelector.vue';

var AppSimpleDistrictSelector = /*#__PURE__*/function (_GetAllDistricts) {
  _inherits(AppSimpleDistrictSelector, _GetAllDistricts);

  var _super = _createSuper(AppSimpleDistrictSelector);

  function AppSimpleDistrictSelector() {
    var _this;

    _classCallCheck(this, AppSimpleDistrictSelector);

    _this = _super.apply(this, arguments);
    _this.model = null;
    _this.province = -1;
    _this.city = -1;
    _this.region = -1;
    _this.school = -1;
    _this.provinceName = '';
    _this.cityName = '';
    _this.regionName = '';
    _this.schoolName = '';
    _this.districtLoading = false;
    _this.initValueArr = [];
    return _this;
  }

  _createClass(AppSimpleDistrictSelector, [{
    key: "mounted",
    value: function mounted() {
      this.model = this.value || null;
      this.getProvinces();
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val, oldVal) {
      if (!val) {
        this.model = val;
        this.province = -1;
        this.city = -1;
        this.region = -1;
        this.school = -1;
        this.provinceName = '';
        this.cityName = '';
        this.regionName = '';
        this.schoolName = '';
      }

      if (!oldVal) {
        this.initValueArr = (val.mergerName || '').split(',');
        this.getProvinces();
      }
    }
  }, {
    key: "onProvinceChanged",
    value: function onProvinceChanged(val) {
      if (val !== -1) {
        var province = this.provinces[val];
        this.getCities(Number(province.id));
        this.model = province;
      } else {
        this.model = null;
      }

      this.city = -1;
      this.region = -1;
      this.school = -1;
      this.cityName = '';
      this.regionName = '';
      this.schoolName = '';
      this.valueChangedHandler();
    }
  }, {
    key: "onCityChanged",
    value: function onCityChanged(val) {
      if (val === -1) {
        var province = this.provinces[this.province];
        this.model = province;
      } else {
        var city = this.cities[val];
        this.getRegions(city.id);
        this.cityName = city.name;
        this.model = city;
      }

      this.region = -1;
      this.valueChangedHandler();
    }
  }, {
    key: "onDistrictChanged",
    value: function onDistrictChanged(val) {
      if (val === -1) {
        var province = this.provinces[this.province];
        var city = this.cities[this.city];
        this.model = this.city === -1 ? province : city;
      } else {
        var region = this.regions[val];
        this.regionName = region.name;
        this.model = region;
      }

      this.valueChangedHandler();
    }
  }, {
    key: "onProvincesUpdated",
    value: function onProvincesUpdated(val) {
      var _this2 = this;

      if (this.initValueArr.length <= 1) {
        this.province = -1;
        this.city = -1;
        this.region = -1;
      } else {
        this.province = val.findIndex(function (province) {
          return province.name === _this2.initValueArr[1];
        });
      }
    }
  }, {
    key: "onCitiesUpdated",
    value: function onCitiesUpdated(val) {
      var _this3 = this;

      if (this.initValueArr.length <= 2) {
        this.city = -1;
        this.region = -1;
      } else {
        this.city = val.findIndex(function (city) {
          return city.name === _this3.initValueArr[2];
        });
      }
    }
  }, {
    key: "onRegionsUpdated",
    value: function onRegionsUpdated(val) {
      var _this4 = this;

      if (this.initValueArr.length <= 3) {
        this.region = -1;
      } else {
        this.region = val.findIndex(function (region) {
          return region.name === _this4.initValueArr[3];
        });
      }
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler() {
      return this.model;
    }
  }, {
    key: "submit",
    value: function submit() {}
  }]);

  return AppSimpleDistrictSelector;
}(GetAllDistricts);

__decorate([Prop(Object)], AppSimpleDistrictSelector.prototype, "value", void 0);

__decorate([Prop(Boolean)], AppSimpleDistrictSelector.prototype, "showSchool", void 0);

__decorate([Prop({
  type: String,
  default: '地区：'
})], AppSimpleDistrictSelector.prototype, "label", void 0);

__decorate([Prop({
  type: String,
  default: '120'
})], AppSimpleDistrictSelector.prototype, "width", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleDistrictSelector.prototype, "disabled", void 0);

__decorate([Watch('value')], AppSimpleDistrictSelector.prototype, "onValueChanged", null);

__decorate([Watch('province')], AppSimpleDistrictSelector.prototype, "onProvinceChanged", null);

__decorate([Watch('city')], AppSimpleDistrictSelector.prototype, "onCityChanged", null);

__decorate([Watch('region')], AppSimpleDistrictSelector.prototype, "onDistrictChanged", null);

__decorate([Watch('provinces')], AppSimpleDistrictSelector.prototype, "onProvincesUpdated", null);

__decorate([Watch('cities')], AppSimpleDistrictSelector.prototype, "onCitiesUpdated", null);

__decorate([Watch('regions')], AppSimpleDistrictSelector.prototype, "onRegionsUpdated", null);

__decorate([Emit('input')], AppSimpleDistrictSelector.prototype, "valueChangedHandler", null);

__decorate([Emit()], AppSimpleDistrictSelector.prototype, "submit", null);

AppSimpleDistrictSelector = __decorate([Component({
  components: {
    AppSimpleSelector: AppSimpleSelector
  }
})], AppSimpleDistrictSelector);
export default AppSimpleDistrictSelector;